import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AttachmentsManagementsService {
  private url: string = environment.apiUrl;
  constructor(private http: HttpClient) {}
  CreateAttachment(data: FormData) {
    return this.http.post(`${this.url}Users/CreateUserAttachment`, data);
  }
  GetAllAttachments(userId, pageSize, pageIndex) {
    return this.http.get(`${this.url}Users/GetAllAttachment/${userId}/${pageSize}/${pageIndex}`);
  }
  DeleteAttachment(id: number) {
    return this.http.delete(`${this.url}Users/DeleteUserAttachment/${id}`);
  }
  GetAttachmentById(id: number) {
    return this.http.get(`${this.url}Users/GetUserAttachment/${id}`);
  }

  UpdateAttachment(data: FormData) {
    return this.http.put(`${this.url}Users/UpdateUserAttachment`, data);
  }
  // file Service
  Download(fileName: string) {
    return this.http.get(`${this.url}File/Download/${fileName}`, { responseType: 'blob' });
  }
}
